module.exports = __webpack_public_path__ + "static/media/React js.07769811.png";